import { useState, useEffect, useCallback } from 'react';
import {
  fetchGlobalCondoDetailsCustomOptions,
  getCondoCustomOptionUsageMap
} from '../services/condoDetailsCustomService';

export function useCondoDetailsCustomCatalog(enabled = true, { includeUsage = true } = {}) {
  const [catalog, setCatalog] = useState([]);
  const [usageMap, setUsageMap] = useState({});
  const [loading, setLoading] = useState(Boolean(enabled));

  const reload = useCallback(async () => {
    if (!enabled) {
      setCatalog([]);
      setUsageMap({});
      setLoading(false);
      return;
    }
    setLoading(true);
    try {
      const options = await fetchGlobalCondoDetailsCustomOptions();
      setCatalog(options);
      setLoading(false);

      if (includeUsage) {
        try {
          const usage = await getCondoCustomOptionUsageMap();
          setUsageMap(usage);
        } catch (usageError) {
          console.error('Erro ao carregar uso das opções do condomínio:', usageError);
          setUsageMap({});
        }
      } else {
        setUsageMap({});
      }
    } catch (error) {
      console.error('Erro ao carregar opções personalizadas do condomínio:', error);
      setCatalog([]);
      setUsageMap({});
      setLoading(false);
    }
  }, [enabled, includeUsage]);

  useEffect(() => {
    reload();
  }, [reload]);

  return { catalog, usageMap, loading, reload, setCatalog, setUsageMap };
}
